import eventHub from "./eventHub.js";
import auth from "./auth.js";
import util from "./util.js";

// firebase.database.enableLogging(false, false); //TODO - Use this to investigate block issues

let db = firebase.database();
let app = {};
let uid = "";
let connected = false;
let timeout;

db.ref(".info/connected").on("value", function(snapshot) {
  connected = snapshot.val();
});

eventHub.$on("user-logged-in", function() {
  uid = auth.getUser().uid;
  updateLastLogin();
  eventHub.$emit("user-db-ready");
});

const updateLastLogin = function() {
  db.ref("users/" + uid + "/activity").update({
    last_login: Date.now(),
  });
};

const updateLastActivity = function() {
  clearTimeout(timeout);
  timeout = setTimeout(function() {
    db.ref("users/" + uid + "/activity").update({
      last_activity: Date.now() - 1000,
    });
  }, 1000);
};

const base = {
  db: db,
  setVueInstance(instance) {
    app = instance;
  },
  userRef(query = "") {
    //FIXME - Add checking here to make sure we're okay before proceeding
    return db.ref("users/" + uid + "/" + query);
  },
  isBetaUser() {
    //FIXXME - TEST THIS WITH A NON-BETA ACCOUNT
    return app.settings ? app.settings.betaUser || false : false;
  },
  trashCategory(categoryId) {
    const category = app.categories[categoryId] || {};

    if (categoryId === {}) {
      return console.error("Unable to delete ", categoryId, " - Category Not Found");
    }

    if (category.parentId) {
      this.removeChildCategory(category.parentId, categoryId);
    }

    if (category.children) {
      Object.keys(category.children).forEach(childId => this.removeParentCategory(childId));
    }

    //FIXME - Add cleanup/permanant delete option/logic
    this.userRef("categories/" + categoryId).update({
      "/inTrash": true,
      "/inTrashOrArchived": true,
    });

    base.stopListeningCategory(categoryId);

    ga("send", "event", "categories", "delete", category.parentId != "" ? "child" : "parent");

    updateLastActivity();
  },
  removeChildCategory(parentId, childId) {
    const parent = app.categories[parentId];
    if (Object.keys(parent.children).length == 1) {
      base.setSubcategoryVisibility(parentId, false);
    }

    //FIXME - Add error checking please!
    this.userRef("categories/" + parentId + "/children")
      .child(childId)
      .remove();
  },
  archiveCategory(categoryId) {
    const category = app.categories[categoryId] || {};

    if (categoryId === {}) {
      return console.error("Unable to delete ", categoryId, " - Category Not Found");
    }

    //TODO - Have some way to show archived children in parent category
    if (category.parentId) {
      this.removeChildCategory(category.parentId, categoryId);
    }

    if (category.children) {
      Object.keys(category.children).forEach(childId => this.archiveCategory(childId));
    }

    this.userRef("categories/" + categoryId).update({
      "/archived": true,
      "/inTrashOrArchived": true,
    });

    base.stopListeningCategory(categoryId);

    ga("send", "event", "categories", "archive", category.parentId != "" ? "child" : "parent");

    updateLastActivity();
  },
  removeChildCategory(parentId, childId) {
    const parent = app.categories[parentId];
    if (Object.keys(parent.children).length == 1) {
      base.setSubcategoryVisibility(parentId, false);
    }

    //FIXME - Add error checking please!
    this.userRef("categories/" + parentId + "/children")
      .child(childId)
      .remove();
  },
  removeParentCategory(categoryId) {
    //FIXME - Add error checking please!
    this.userRef("categories/" + categoryId + "/parentId").set("");
  },
  loadUserData() {
    // FIXME - THIS IS BEING CALLED WAY TOO MUCH
    base
      .userRef("categories")
      .orderByChild("inTrashOrArchived")
      .equalTo(null)
      .on("value", function(snapshot) {
        // console.warn("Updated Pre-Length", Object.keys(app.categories));
        let newData = util.mergeObjects(snapshot.exists() ? snapshot.val() : {}, app.categories) || {};
        // console.warn("Updated Post-Length", Object.keys(newData));
        let newCategories = Object.keys(newData).filter(d => {
          return !Object.keys(app.categories).includes(d);
        });

        Vue.set(app, "categories", util.normalizeCategories(newData));

        //TODO - Load this async for better performance but make sure we're only displaying blocks for active categories
        base.loadTodaysBlocks();

        //Load data for our new categories
        newCategories.forEach(categoryId => {
          base.loadPast7DaysCategory(categoryId);
          base.loadCategorySummaries(categoryId);
        });
      });
    base.userRef("settings").on("value", function(snapshot) {
      Vue.set(app, "settings", snapshot.exists() ? snapshot.val() : {});
    });
  },
  loadTodaysBlocks() {
    this.userRef("days/" + util.getCurrentDay()).on("value", function(snapshot) {
      let today = snapshot.exists() ? snapshot.val() : {};
      let categories = app.categories;

      for (let categoryId in today) {
        // This deals with this query completing before the categories query
        if (!categories[categoryId]) {
          continue;
          // FIXME - This causes problems when we load async for categories with blocks that have been deleted/archived
          // Vue.set(app.categories, categoryId, {});
        }
        Vue.set(app.categories[categoryId], "blocks", today[categoryId]);
      }
      // Remove blocks from categories whose keys are no longer in the snapshot
      for (let category in categories) {
        if (!today[category]) {
          Vue.set(app.categories[category], "blocks", {});
        }

        //FIXME - This can be cleaner
        let totalBlocks = Object.assign({}, categories[category].blocks || {});
        let children = categories[category].children || {};
        Object.keys(children).forEach(childId => {
          if (!app.categories[childId]) {
            return;
          }
          Object.assign(totalBlocks, categories[childId].blocks || {});
        });
        Vue.set(app.categories[category], "totalBlocks", totalBlocks);
      }
    });
  },
  //Returns block counts for all of the days that fall within the calendar week of the
  //specified date
  //FIXME - Do we want to do this with a callback or as a promise?
  getWeekSummaries(date, callback) {
    const dates = util.getWeek(date);
    console.log("IMPLEMENT ME", dates);
    //Get those summaries
    //Save summaries in a nice format
  },
  // TODO - See if this is necessary after we create the summary object(s) in Firebase
  loadPast7DaysCategory(categoryId) {
    let category = app.categories[categoryId];
    Vue.set(app.categories[categoryId], "days", {});

    util.getLast7Days().forEach(date => {
      const summaryDate = date.replace(/-/g, "/");
      this.userRef("summaries/" + summaryDate + "/" + categoryId)
        .once("value")
        .then(snapshot => {
          let count = snapshot.exists() ? snapshot.val() : 0;
          Vue.set(app.categories[categoryId].days, date, count);
        });
    });
  },
  loadAndListenDay(date, callback) {
    this.userRef("days/" + date).on("value", snapshot => {
      callback(snapshot.val());
      // FIXME - Add error checking
    });
  },
  stopListeningDay(date) {
    this.userRef("days/" + date).off();
  },
  stopListeningCategory(categoryId) {
    const d = util.getCurrentDayMoment();
    const year = d.format("YY");
    const month = d.format("MM");
    const day = d.format("DD");

    this.userRef("summaries/" + categoryId).off();
    this.userRef("summaries/" + year + "/" + categoryId).off();
    this.userRef("summaries/" + year + "/" + month + "/" + categoryId).off();
  },
  isConnected() {
    return connected;
  },
  addBlock(categoryId, date = util.getCurrentDay()) {
    this.userRef("days/" + date + "/" + categoryId).push({
      ts: Date.now(),
    });

    // FIXME - Take into account when we delete blocks
    this.userRef("categories/" + categoryId).update({
      last_block_added: Date.now(),
    });

    let incrementSummary = function(summary) {
      if (!summary) {
        summary = {};
      }

      summary[categoryId] = summary[categoryId] ? ++summary[categoryId] : 1;
      summary.total = summary.total ? ++summary.total : 1;

      return summary;
    };

    const d = moment(date, util.dateString);
    const year = d.format("YY");
    const month = d.format("MM");
    const day = d.format("DD");

    this.userRef("summaries").transaction(incrementSummary);
    this.userRef("summaries/" + year).transaction(incrementSummary);
    this.userRef("summaries/" + year + "/" + month).transaction(incrementSummary);
    this.userRef("summaries/" + year + "/" + month + "/" + day).transaction(incrementSummary);

    ga("send", "event", "blocks", "add");

    updateLastActivity();
  },
  removeBlock(categoryId, blockId, date = util.getCurrentDay()) {
    this.userRef("days/" + date + "/" + categoryId)
      .child(blockId)
      .remove();

    let decrementSummary = function(summary) {
      if (!summary) {
        summary = {};
      }

      //Eliminate category from storage if it's no longer being used
      summary[categoryId] = summary[categoryId] > 1 ? --summary[categoryId] : null;
      summary.total = summary.total > 1 ? --summary.total : null;

      return summary;
    };

    const d = moment(date, util.dateString);
    const year = d.format("YY");
    const month = d.format("MM");
    const day = d.format("DD");

    this.userRef("summaries").transaction(decrementSummary);
    this.userRef("summaries/" + year).transaction(decrementSummary);
    this.userRef("summaries/" + year + "/" + month).transaction(decrementSummary);
    this.userRef("summaries/" + year + "/" + month + "/" + day).transaction(decrementSummary);

    ga("send", "event", "blocks", "remove");

    updateLastActivity();
  },
  setSubcategoryVisibility(categoryId, isVisible) {
    this.userRef("categories/" + categoryId).update({
      "showChildren/": isVisible,
    });

    updateLastActivity();
  },
  loadCategorySummaries(categoryId, date = util.getCurrentDay()) {
    //FIXME - Get a handle on this and the normalization, please
    console.log("WE ARE CALLING THIS TOO MANY TIMES! FIXME PLEASE");
    //Load past year, month, and week(s)?
    const d = moment(date, util.dateString);
    const year = d.format("YY");
    const month = d.format("MM");
    const day = d.format("DD");

    Vue.set(app.categories[categoryId], "summaries", {});

    // FIXME - Decide if it's a good idea to actually be constantly listening for these changes...
    this.userRef("summaries/" + categoryId).on("value", snapshot => {
      // console.log("STOP LISTENING");
      Vue.set(app.categories[categoryId].summaries, "total", snapshot.val() || 0);
    });
    this.userRef("summaries/" + year + "/" + categoryId).on("value", snapshot => {
      // console.log("STOP LISTENING");
      Vue.set(app.categories[categoryId].summaries, "year", snapshot.val() || 0);
    });
    this.userRef("summaries/" + year + "/" + month + "/" + categoryId).on("value", snapshot => {
      // console.log("STOP LISTENING");
      Vue.set(app.categories[categoryId].summaries, "month", snapshot.val() || 0);
    });
    // this.userRef("summaries/" + year + "/" + month + "/" + day + "/" + categoryId).on("value", snapshot => {
    //     Vue.set(app.categories[categoryId].summaries, "day", snapshot.val() || 0);
    // });
  },
  getPast7Days() {
    util.getLast7Days().forEach(date => {
      this.userRef("days/" + date)
        .once("value")
        .then(snapshot => {
          const data = snapshot.exists() ? snapshot.val() : {};
          Vue.set(app.days, date, data);
        });
    });
  },
  async loadSummaryLastNDays(n = 90) {
    const months = Math.ceil(n / 30) + 1;
    console.log("Loading last", months, "months");
    const totals = {};
    const m = moment();
    for (let i = 0; i < months; i++) {
      const monthSummaries = await this.userRef(`summaries/${m.format("YY/MM")}`).once("value");
      if (!totals[m.format("YY")]) {
        totals[m.format("YY")] = {};
      }
      totals[m.format("YY")][m.format("MM")] = monthSummaries.val();
      m.subtract(1, "month");
    }
    return totals;
  },
};

export default base;



// WEBPACK FOOTER //
// ./dev/src/db.js